export default function removeQuoteWrapsIfExists(str: string) {
  const textBetweenquotes = new RegExp(/"([^"]+)"/);
  let dslValue = str;
  const match = textBetweenquotes.exec(dslValue);
  if (match) {
    dslValue = match[1];
  }
  return dslValue;
}
